import React from 'react'
import ButtonV2 from 'src/components/ButtonV2';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
interface PropsType {
    message: string
}
const DownloadCSV: React.FC<PropsType> = ({ message }) => {
    return (
        <div className='create-agent-container'>
            <ButtonV2 onClick={() => window.open(message, '_blank', 'noopener,noreferrer')} text='Click Here To Download' type='primary' startIcon={<CloudDownloadIcon />} />
        </div>
    )
}

export default DownloadCSV;
